import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";

import { allIngredientReferencesKey } from "./useAllIngredientReferences";

export function useDeleteIngredientReference() {
    const queryClient = useQueryClient();

    const query = useMutation({
        mutationFn: async (id: number) => {
            const response = await loggedInApiCall.delete("/api/ingredient-references/" + id);
            return response;
        },
        onSuccess: () => queryClient.invalidateQueries([allIngredientReferencesKey]),
    });

    return query;
}
